import { Component, OnInit } from '@angular/core';
import {AppTreeDiagramService } from './app-tree-diagram.service';
import { TranslationService } from 'angular-l10n';
import { HumanResourcesComponent } from '../../views/human-resources/human-resources.component';
import {MatProgressSpinnerModule, MatGridListModule} from '@angular/material';
import { HumanResourcesService } from '../../views/human-resources/human-resources.service';
import {MatTabsModule} from '@angular/material/tabs';
import {MatInputModule} from '@angular/material/input';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from "../../views/authentication/authentication.service";
import {MatFormFieldModule} from '@angular/material/form-field';

@Component({
  selector: 'app-tree-diagram',
  templateUrl: './app-tree-diagram.component.html',
  styleUrls: ['./app-tree-diagram.component.scss'],
})

export class AppTreeDiagramComponent implements OnInit {
  constructor(private service :AppTreeDiagramService)
  { }

  public globalTotal:any;
  private http: HttpClient;
  private auth: AuthenticationService;
  public humanService = new HumanResourcesService(this.http,this.auth);

  public test: boolean = true;
  public MatTabs :MatTabsModule;
  public MatIn :MatInputModule;
  public trans : TranslationService;
  public spinn :MatProgressSpinnerModule;
  public grid :MatGridListModule;
  public frmfield: MatFormFieldModule;
  public humanPage = new HumanResourcesComponent(this.humanService,this.trans,this.spinn,this.grid,this.MatTabs,this.MatIn,this.frmfield);

  public otherTree:any;
  public tree: any;
  public arbol:any;
  public Guid:any =[];
  
  public Children: any = [];
  public LocalChildren: any = [];
  public data: any = [];
  public nombre: any;
  public info: any;
  public datos: any=[];
  public id: any;
  public tipo: any;
  public i: number = 0;
  public redValue: any;
  public Total :number =0;
  public newIds: any=[];
  public arreglo: any=[];
//
  public budg : number;
  //
  public arrtest: any = [];
  public respuesta: any;

  public datoscrudos:any;
  public newData: any;
  public newTotal: any;
  public newKind: any;

  createRawTree()
  {
      this.service.getData().subscribe((response:any=[])=> {
        response.dependencies.forEach(child => {
          this.LocalChildren.push(child.encoded_key);
        });
        this.NewRecursiveFunction(response.encoded_key,response.dependencies, null);
        this.arrtest = {
          "entities":this.data
        }
        console.log(this.arrtest);
        this.service.newcode().subscribe((response:any=[])=> {
          console.log(response);
          
          for (var x in this.data){ //recorre cada guid *no puedo sacar el guid de response
            
              this.NewfindAndReplace(this.data,this.data[x].guid ,response[this.data[x].guid].Data, response[this.data[x].guid].Kind, response[this.data[x].guid].Total );
                
                //al objeto data, va a buscar el primer id de sí mismo, cuando lo encuentre, reemplaza el Data, reemplaza el Kind y el Total
          }
        });
        console.log("datos final");
        console.log(this.data);
        this.tree = {
          json: this.data,
          config: this.treeConfig
          };
          
      });
      

  }


loadingScreen(){
  this.humanPage.Isloading = false;
}

  NewfindAndReplace(object, value, replacedata, replaceKind, replaceTotal) {
    //object = json donde se va a reemplazar
    //value = valor de comparacion, en este caso, el guid
    //replace = valor a reemplazar.
   for (var x in object) {
     if (object.hasOwnProperty(x)) {
       if (typeof object[x] == 'object') {
         this.NewfindAndReplace(object[x], value, replacedata, replaceKind, replaceTotal);
       }
       if (object[x] == value) {
        
        if (object["guid"] == value){

          object["Data"] = replacedata;
          object["Kind"] = replaceKind;
          object["Total"] = replaceTotal;
          if (replacedata.Budget  < replaceTotal)
          {
            object["Red"] = true;
          }

        }
        
       }
     }
     this.tree = {
      json: this.data,
      config: this.treeConfig
      };
   }
 }

  public treeConfig = {
    nodeWidth: 200,
    nodeHeight: 150
  };

  MoveNode(origen:any, destino:any)
  {
    //console.log("Mover:"+ origen+ " a " + destino);

     this.newIds = {
      'entityToChange': origen,
      'newParent': destino
    };

   this.service.changeParent(this.newIds).subscribe((response: any) => {
    });
    this.ngOnInit();
  }

  NewRecursiveFunction(key:any, Blessings:any=[],parent:any){

    this.LocalChildren=[];
    //key = father
    if (Blessings.length == 0)
    {
      this.LocalChildren = [];

          this.data.push
          ({
            guid:key,
            Data: null,
            Kind: null,
            Total: null,
            Red: null,
            parentId:parent,
            children:this.LocalChildren
          });
      
    
    }
    else
    {
      
        for (var _i = 0; _i < Blessings.length; _i++) {
          this.LocalChildren.push(Blessings[_i].encoded_key);
        }

            this.data.push
            ({
              guid:key,
              Data: null,
              Kind: null,
              Total: null,
              Red: null,
              parentId:parent,
              children:this.LocalChildren
            });
          
          

      //IF
        for (var _i = 0; _i < Blessings.length; _i++) 
        {      
          this.NewRecursiveFunction(Blessings[_i].encoded_key,Blessings[_i].dependencies,key); 
        }
    
    }

  }



  ngOnInit() {    
    this.createRawTree();


  }

  

}


// WEBPACK FOOTER //
// ./src/app/components/app-tree-diagram/app-tree-diagram.component.ts